import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/global.css'
import '@fortawesome/fontawesome-free/css/all.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
